import FieldProto from "../../../proto/field-proto";
import FieldConfig from "../../../proto/field-config";
import FieldCompanyUserWorkSchedule_View from "./components/view/view";


export default class FieldCompanyUserWorkSchedule extends FieldProto {

    constructor(config:FieldConfig) {
        super(config);

        this.icon           = 'i5-calendar'

        this.renderComponents.view      = FieldCompanyUserWorkSchedule_View
        this.renderComponents.glistView = FieldCompanyUserWorkSchedule_View
    }
}
